import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LineString, Point } from "ol/geom";
import { Vector } from "ol/source";
import { Fill, Icon, Stroke, Style, Text } from "ol/style";
import { MapService } from 'src/app/services/map.service';
import { OtherService } from 'src/app/services/other.service';
import { AccountService } from '../services/account.service';
import { MapBuilderService } from '../services/map-builder.service';
import axios from "src/app/services/axios";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Feature from 'ol/Feature';
import * as olProj from 'ol/proj';
import "ol/ol.css";

declare let $: any;

@Component({
  selector: 'app-custom-map',
  templateUrl: './custom-map.component.html',
  styleUrls: ['./custom-map.component.css']

})

export class CustomMapComponent implements OnInit {
  @Input() str_Placeholder: string = ""; //? تکست باکس - اختیاری 'placeholder' 
  @Input() stylesArray!: any[]; //? تکست باکس - اختیاری 'style' 
  @Input() strValue!: string; //? مقدار اولیه تکست باکس - اختیاری
  @Input() isDisabled: boolean = false; //? غیرفعال بودن تکست باکس - اختیاری
  @Input() longLat: number[] = [51.3833554, 35.6770113]; //? موقعیت پیش فرض نقشه
  @Input() isTextArea: boolean = true; //? انتخاب حالت دریافت آدرس
  @Input() isLocationBtn: boolean = true; //? انتخاب حالت نمایش دکمه نقشه
  @Input() isOpenModal: boolean = false; //? نمایش نقشه در ابتدا
  @Input() isShowAll: boolean = false; //? نمایش همه مختصات در نقشه
  @Input() lst_Array!: any[]; //? لیست اصلی شامل تمام نقاط 
  @Input() lat_StrKey!: string; //? کلید عرض جغرافیایی در لیست
  @Input() lon_StrKey!: string; //? کلید طول جغرافیایی در لیست
  @Input() MARKER_ICON: string = '../../../assets/imgs/mapicon-32x32.png'; //? آیکون مارکر روی نقشه
  @Input() skip_Search: boolean = false; //?  skip searching by address
  @Input() isShowFooter: boolean = true; //?  انتخاب حالت نمایش فوتر مدال
  @Input() isDrawRoute: boolean = false; //? ترسیم مسیر روی نقشه
  @Input() objRoute!: any; //? اطلاعات ترسیم مسیر
  @Input() sLonLat!: any[]; //? مختصات نقطه شروع
  @Input() dLonLat!: any[]; //? مختصات نقطه پایان
  @Output() mdl_Submit = new EventEmitter(); //? بستن نقشه بعد از کلیک بر روی آیتم
  map: any;
  vector: any;
  source: any;
  layers: any = [];
  bShowModal: boolean = false;
  vectorLayer: any;
  mdl_Map: FormGroup = this._fb.group({

    strText: new FormControl(''),

    strText_Toolbar: new FormControl(''),

    strAddress: new FormControl(''),

    strCity: new FormControl(''),

    strState: new FormControl(''),

    isChanged: new FormControl(false),

    latitude: new FormControl(0),

    longitude: new FormControl(0)

  })

  constructor(
    private mapService: MapService,
    private mapBuilderService: MapBuilderService,
    private _fb: FormBuilder,
    private _other: OtherService,
    private _acc: AccountService

  ) { }

  ngOnInit(): void {


    if (this.isDrawRoute && !this.objRoute) {

      throw new Error('objRoute is required.');

    }

    if (this.isDrawRoute && (!this.sLonLat || !this.dLonLat)) {

      throw new Error('both sLonLat & dLonLat is required.');

    }

    if (this.isShowAll) {

      this.openMap();

    }

    if (this.isShowAll && !this.lst_Array.length) {

      throw new Error('lst_Array is required.');

    }

    if (this.isShowAll && (!this.lat_StrKey || !this.lon_StrKey)) {

      throw new Error('both lat_StrKey and lon_StrKey is required!');


    }

    if (this.isShowAll && !this.stylesArray) {

      throw new Error('stylesArray is required(define with and height).');

    }

    if (this.longLat[0] == 0 || this.longLat[1] == 0) {

      this.longLat = [51.3833554, 35.6770113]

    }

    if (this.strValue && this.strValue != '') {

      this.mdl_Map.controls['strText'].setValue(this.strValue);

      this.mdl_Map.controls['strText_Toolbar'].setValue(this.strValue);

    }

    if (this.isOpenModal) {

      if (this.strValue && this.strValue != '' && !this.isDrawRoute) {

        this.mdl_Map.controls['isChanged'].setValue(true);

        this.openMap();

      }

      else {

        this.openMap();

      }

    }

    if (this.isDrawRoute) {

      this.mdl_Map.controls['strText_Toolbar'].setValue(this.strValue);

      this.route_Drawing()

    }

    if (this.isDisabled || !this.isLocationBtn) {

      this.mdl_Map.controls['strText'].disable()

    }

    if (!this.isShowFooter || this.isDrawRoute) {

      this.mdl_Map.controls['strText_Toolbar'].disable()

    }


  }

  ngOnDestroy() {

    $('#map_Modal').modal('hide');

  }

  onInput() {

    this.mdl_Map.controls['isChanged'].setValue(true);

    // اگر کاربر متنی را به آدرس اضافه کرد

    this.mdl_Submit.emit(this.mdl_Map.value)

  }

  async openMap() {

    // اگر کاربر چیزی را تایپ کرده بود

    if (this.mdl_Map.get('isChanged')?.value && !this.skip_Search) {

      let res = (await axios.post(`Geocoding`, { 'strAddress': this.mdl_Map.get('strText')?.value })).data;

      this.mdl_Map.controls['isChanged'].setValue(false);

      if (res.fLat != 0 && res.fLon != 0) {

        this.longLat = [res.fLon, res.fLat];

        this.mdl_Map.controls['strText_Toolbar'].setValue(res.strAddress);

        this.mdl_Map.controls['strText'].setValue(res.strAddress);

        this.mdl_Map.controls['strAddress'].setValue(res.strAddress);

        this.mdl_Map.controls['strCity'].setValue(res.strCity);

        this.mdl_Map.controls['strState'].setValue(res.strState);

        this.mdl_Map.controls['latitude'].setValue(res.fLat);

        this.mdl_Map.controls['longitude'].setValue(res.fLon);

      }

      else {

        this._acc.toastSwal('error', '!آدرس یافت نشد')

      }

      this.newOpenMap();

    }

    // اگر کاربر چیزی را تایپ نکرده بود

    else {

      this.newOpenMap();

    }

  }

  newOpenMap() {

    if (this.isShowAll == false) {

      $('#map_Modal').modal('show');

    }

    setTimeout(() => {

      this.map = this.mapBuilderService.createMap('map_Container', this.longLat);

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/imgs/marker4.png'

        }))

      });

      if (!this.isShowAll && !this.isDrawRoute) {

        const marker = new Feature({

          geometry: new Point(olProj.fromLonLat(this.longLat)),

        });

        const vectorLayer = new VectorLayer({

          source: new VectorSource({

            features: [marker],

          }),

          style: new Style({

            image: new Icon({

              src: '../../assets/imgs/marker4.png',

              scale: 1.0,

            }),

          }),

        });

        this.map.addLayer(vectorLayer);

        this.map.on('click', (e: any) => {

          if (this.isShowAll || !this.isShowFooter) return; // disable click in isShowAll mode

          this.map.removeLayer(vectorLayer)

          if (e.dragging) return;

          var coords = olProj.toLonLat(e.coordinate);

          this.mdl_Map.controls['latitude'].setValue(coords[1]);

          this.mdl_Map.controls['longitude'].setValue(coords[0]);

          this.submitAddress(true)

          var iconGeometry = new Point(e.coordinate)

          var iconFeature = new Feature({

            geometry: iconGeometry,

          });

          iconFeature.setStyle(iconStyle);

          var vectorSource = new Vector({

            features: [iconFeature]

          });

          var dinamicPinLayer = new VectorLayer({

            source: vectorSource

          });

          this.map.getLayers().forEach((layer: VectorSource) => {

            let layers = this.map.getLayers().getArray();

            for (const item of layers) {

              if (item.getKeys().length < 11) {

                this.map.removeLayer(item);

              }

            }

          });

          this.map.addLayer(dinamicPinLayer);

          var view = this.map.getView();

          // view.animate({

          //   center: olProj.transform(

          //     [coords[0], coords[1]],

          //     'EPSG:4326',

          //     'EPSG:3857'
          //   ),

          //   duration: 1000,

          // });

        })

      }

      if (this.isShowAll && this.lst_Array.length) {

        this.showAllInMap();

      }

    }, 500);

  }

  async submitAddress(isClicked: boolean = false) {

    if (isClicked) {

      let model = {

        fLat: this.mdl_Map.controls['latitude'].value,

        fLon: this.mdl_Map.controls['longitude'].value,

      }

      const address = await axios.post(`ReverseGeocoding`, this._other.stringNumberToNumber(model));


      this.mdl_Map.get('strText_Toolbar')?.setValue(address.data.strAddress);

    }

    else {

      this.longLat = [this.mdl_Map.get('longitude')?.value, this.mdl_Map.get('latitude')?.value];

      this.mdl_Map.get('strText')?.setValue(this.mdl_Map.get('strText_Toolbar')?.value);

      this.mdl_Map.get('strAddress')?.setValue(this.mdl_Map.get('strText_Toolbar')?.value);

      this.mdl_Submit.emit(this.mdl_Map.value);

      $('#map_Modal').modal('hide');


    }

  }

  async getLatLong() {

    if (!this.isShowFooter && this.isDrawRoute) return;

    let res = (await axios.post(`Geocoding`, { 'strAddress': this.mdl_Map.get('strText_Toolbar')?.value })).data;

    this.mdl_Map.get('longitude')?.setValue(res.fLon);

    this.mdl_Map.get('latitude')?.setValue(res.fLat);

    this.mdl_Map.get('strText_Toolbar')?.setValue(res.strAddress);

    // پاک کردن موقعیت قبلی از روی نقشه

    this.map.getLayers().forEach((layer: VectorSource) => {

      let layers = this.map.getLayers().getArray();

      for (const item of layers) {

        if (item.getKeys().length < 11) {

          this.map.removeLayer(item);

        }

      }

    });

    // ترسیم موقعیت جدید روی نقشه

    const marker = new Feature({

      geometry: new Point(olProj.fromLonLat([res.fLon, res.fLat])),

    });

    const vectorLayer = new VectorLayer({

      source: new VectorSource({

        features: [marker],

      }),

      style: new Style({

        image: new Icon({

          src: '../../assets/imgs/marker4.png',

          scale: 1.0,

        }),

      }),

    });

    this.map.addLayer(vectorLayer);

    // زوم روی ناحیه دریافت شده

    var view = this.map.getView();

    view.animate({

      center: olProj.transform(

        [res.fLon, res.fLat],

        'EPSG:4326',

        'EPSG:3857'
      ),

      duration: 1000,

    });

  }

  getStylesObject(): { [key: string]: string } {

    if (!this.stylesArray) return {};

    let styles: { [key: string]: string } = {};

    this.stylesArray.forEach(styleString => {

      const [property, value] = styleString.split(':').map((s: any) => s.trim());

      styles[property] = value;

    });

    return styles;

  }

  showAllInMap() {

    this.lst_Array.forEach((point: any) => {

      if (point[this.lat_StrKey] !== 0 && point[this.lon_StrKey] !== 0) {

        const iconStyle = new Style({

          image: new Icon({

            src: this.MARKER_ICON,

            size: [40, 38],

            anchor: [0.5, 1],

          }),

        });

        const marker = new Feature({

          geometry: new Point(

            olProj.fromLonLat([point[this.lon_StrKey], point[this.lat_StrKey]])

          ),

        });

        marker.setStyle(iconStyle);

        const vectorSource = new VectorSource({ features: [marker] });

        var vectorLayer = new VectorLayer({

          source: vectorSource,

          name: 'item-icon',

        } as any);

        marker.set('item_data', point);

        this.map.addLayer(vectorLayer);

      }

    });

    this.fitMap(this.lst_Array);


  }

  fitMap(location_Data) {

    let bZoomMap: boolean = true;

    if (!location_Data.length) return;

    let maxLatitude = -Infinity;

    let maxLongitude = -Infinity;

    let minLatitude = Infinity;

    let minLongitude = Infinity;

    for (const item of location_Data) {

      if (item[this.lat_StrKey] !== 0 && item[this.lon_StrKey] !== 0) {

        if (item[this.lat_StrKey] > maxLatitude) maxLatitude = item[this.lat_StrKey];

        if (item[this.lon_StrKey] > maxLongitude) maxLongitude = item[this.lon_StrKey];

        if (item[this.lat_StrKey] < minLatitude) minLatitude = item[this.lat_StrKey];

        if (item[this.lon_StrKey] < minLongitude) minLongitude = item[this.lon_StrKey];

      }

      if (location_Data.length == 1 && item[this.lat_StrKey] == 0 && item[this.lon_StrKey] == 0) {

        return (bZoomMap = false);

      }

    }

    if (bZoomMap) {

      var model = {

        maxLatitude: maxLatitude + 1,

        maxLongitude: maxLongitude + 1,

        minLatitude: minLatitude - 1,

        minLongitude: minLongitude - 1,

      };

      var view = this.map.getView();

      var transformedStart = this.mapService.transformCoordinates2([

        model.maxLongitude,

        model.maxLatitude,

      ]);

      var transformedEnd = this.mapService.transformCoordinates2([

        model.minLongitude,

        model.minLatitude,

      ]);

      var source = [

        Math.min(transformedStart[0], transformedEnd[0]) - 300,

        Math.min(transformedStart[1], transformedEnd[1]) - 300,

        Math.max(transformedStart[0], transformedEnd[0]) + 300,

        Math.max(transformedStart[1], transformedEnd[1]) + 300,

      ];

      view.fit(source);

    }

  }

  route_Drawing() {

    this.map = this.mapBuilderService.createMap('map_Container', [this.sLonLat[0], this.sLonLat[1]]);

    const startCoords = olProj.fromLonLat([this.sLonLat[0], this.sLonLat[1]]);

    const destinationCoords = olProj.fromLonLat([this.dLonLat[0], this.dLonLat[1]]);

    const startFeature = new Feature({

      geometry: new Point(startCoords)

    });

    const destFeature = new Feature({

      geometry: new Point(destinationCoords)

    });

    const startIcon = new Icon({

      src: '../../assets/imgs/marker4.png',

      size: [48, 48],

    });

    const destIcon = new Icon({

      src: '../../assets/imgs/marker5.png',

      size: [48, 48]

    });

    startFeature.setStyle(new Style({

      image: startIcon, text: new Text({

        text: 'مبدأ', // Replace with desired text

        offsetY: -30, // Adjust the vertical position

        font: '16px Vazirmatn', // Set the font style

        fill: new Fill({ color: 'Green' }), // Set the text color

        stroke: new Stroke({ color: 'blue', width: 1 })

      })

    }));

    destFeature.setStyle(new Style({

      image: destIcon, text: new Text({

        text: 'مقصد', // Replace with desired text

        offsetY: -30, // Adjust the vertical position

        font: '16px Vazirmatn', // Set the font style

        fill: new Fill({ color: 'Red' }), // Set the text color

        stroke: new Stroke({ color: 'blue', width: 1 })

      })

    }));

    const routeCoordinates = this.objRoute.data.features[0].geometry.coordinates;

    const transformedRouteCoordinates = routeCoordinates.map((coord: any) => olProj.fromLonLat([coord[0], coord[1]]));

    const routeGeometry = new LineString(transformedRouteCoordinates);

    const routeFeature = new Feature({

      geometry: routeGeometry

    });

    const routeStyle = new Style({

      stroke: new Stroke({

        color: 'green',

        width: 3,

        lineDash: [6, 6]

      }),

    });

    routeFeature.setStyle(routeStyle);

    const vectorSource = new VectorSource({

      features: [startFeature, destFeature, routeFeature]

    });

    this.vectorLayer = new VectorLayer({

      source: vectorSource

    });

    setTimeout(() => {

      this.map.addLayer(this.vectorLayer);

      const iconCoordinates = [startCoords, destinationCoords];

      const boundingBox = new LineString(iconCoordinates).getExtent();

      this.map.getView().fit(boundingBox, { padding: [50, 50, 50, 50] });

    }, 1000);


  }


}
